module.exports = __webpack_public_path__ + "img/fil_rnd_head_sku.prt.f9240bdb.jpg";